module.exports = __webpack_public_path__ + "static/media/Text_ICON1.b178925d.svg";